import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Flex, Form, Layout, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import iconSetting from '../../assets/images/schedules/icon-setting.svg';
import iconLocation from '../../assets/images/segments/icon-location.svg';
import '../../assets/styles/scheduleSetting.scss';
import StepSchedules from '../../components/StepSchedules';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchListPickupLocation, getPickUpLocationTransfer } from '../../redux/slice/pickupLocationSlice';
import { fetchListRoute, getAllRoute } from '../../redux/slice/routeSlice';
import {
  getAllProvinces,
  ListScheduleSelector,
  setListTransships,
  setUpdateLocation,
} from '../../redux/slice/schdules/scheduleSlice';
import LocationModal from './ModalSchedules/LocationModal';

function LocationSetting() {
  const { listSegment, listTransships, listScheduleDetail, isDetailSchedule, isUpdateLocation } =
    useAppSelector(ListScheduleSelector);
  const [form] = Form.useForm();
  const [openModalLocation, setOpenModalLocation] = useState<boolean>(false);
  const [isLastItem, setIsLastItem] = useState<boolean>(false);
  const [segmentActive, setSegmentActive] = useState<any>(1);
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };
  const handleSettingLocation = (location_name: string, index: number) => {
    setOpenModalLocation(true);
    const segmentActiveItem = listSegment?.segment?.length
      ? listSegment?.segment?.filter((item: any) => item?.name === location_name)
      : [];
    if (index + 1 === listSegment?.segment?.length) {
      setIsLastItem(true);
    }
    setSegmentActive(segmentActiveItem);
  };
  const onFinish = (values: any) => {
    if (listTransships) {
      const missingIds = Object.values(listTransships)?.some((group: any) =>
        group?.some((item: any) => item?.pickup_location_id === undefined),
      );
      if (missingIds) {
        toast.error('Vui lòng nhập đủ điểm đón trả');
      } else {
        const allIds = Object.values(listTransships)?.flatMap((group: any) =>
          group.map((item: any) => item?.pickup_location_id),
        );
        const hasDuplicates = new Set(allIds).size !== allIds.length;

        if (!hasDuplicates) {
          navigate('/bus-management/schedules/settings');
          if (isDetailSchedule) {
            dispatch(setUpdateLocation(true));
          }
        } else {
          toast.error('Vui lòng không nhập điểm đón trả trùng nhau');
        }
      }
    } else {
      toast.error('Vui lòng nhập đủ thông tin');
    }
  };

  useEffect(() => {
    dispatch(fetchListRoute({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllRoute({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllProvinces());
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchListPickupLocation({}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getPickUpLocationTransfer({}));
  }, [dispatch]);

  const replaceTransshipObjects = (listTransships: any, listTranShipValue: any) => {
    const mutableListTransships = { ...listTransships };
    Object.keys(mutableListTransships)?.forEach((key) => {
      const segment = mutableListTransships[key]?.[0];
      const segmentName = segment?.name;
      if (segmentName && listTranShipValue[segmentName]) {
        mutableListTransships[key] = listTranShipValue[segmentName]?.map((location: any) => ({
          ...location,
          location_name: segmentName,
          pickup_time: location?.pickup_time?.slice(0, 5),
          name: segmentName,
        }));
      }
    });
    return mutableListTransships;
  };
  useEffect(() => {
    if (isDetailSchedule && listScheduleDetail?.transships && !isUpdateLocation) {
      const updatedListTransships = replaceTransshipObjects(listTransships, listScheduleDetail?.transships);
      dispatch(setListTransships(updatedListTransships));
    }
  }, [isDetailSchedule, listScheduleDetail, isUpdateLocation]);
  return (
    <Layout className="min-vh-70 segment-booking ">
      <Card>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          validateTrigger="onSubmit"
          name="segment-setting-form"
          colon={false}
          labelCol={{ span: 12 }}
          labelAlign={'left'}
          labelWrap
          onFieldsChange={(allFields) => {
            scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
          }}
        >
          <StepSchedules step={2} />
          <div className="segment-block">
            <div className="mt-4 border-b-segment pb-3">
              <Flex gap={16}>
                <img src={iconLocation} alt="" />
                <div>
                  <Typography.Text className="fw-600 fs-18 title-segment">Thiết lập điểm đón trả</Typography.Text>{' '}
                  <br />
                  <Typography.Text className="fw-500 fs-16" style={{ color: '#4F5662' }}>{`Tuyến: ${
                    listSegment?.depart_point ?? ''
                  } - ${listSegment?.arrive_point ?? ''}, Giờ đi: ${listSegment?.depart_time ?? ''}`}</Typography.Text>
                </div>
              </Flex>
            </div>
            <div className="location-content flex mt-4">
              {listSegment?.segment?.map((segment: any, index: number) => {
                const segmentTransships =
                  Object.values(listTransships)
                    .flat()
                    .filter((item: any) => item.location_name === segment.name) || [];
                const hasPickupLocations =
                  segmentTransships.filter((item: any) => item?.pickup_location_id)?.length > 0;
                return (
                  <div
                    className="location-content-item cursor-pointer"
                    key={segment?.name}
                    onClick={() => handleSettingLocation(segment?.name, index)}
                  >
                    <div>
                      <Flex gap={12} align="center">
                        <FontAwesomeIcon
                          icon={faCircle}
                          style={{
                            color: hasPickupLocations ? '#2BA73B' : '#F8B407',
                          }}
                          size="xs"
                        />
                        <Typography.Text className="fw-500 fs-16" style={{ color: '#4F5662' }}>
                          {`${segment?.name} `}
                          <span
                            className="fs-16 fw-500"
                            style={{
                              color: hasPickupLocations ? '#2BA73B' : '#E5AA15',
                            }}
                          >
                            {` (${
                              segmentTransships.filter((item: any) => item?.pickup_location_id).length
                                ? `${
                                    segmentTransships.filter((item: any) => item?.pickup_location_id).length
                                  } điểm đón trả`
                                : 'thiết lập điểm đón trả'
                            })`}
                          </span>
                        </Typography.Text>
                      </Flex>
                    </div>
                    <img src={iconSetting} alt="" className="cursor-pointer" />
                  </div>
                );
              })}
            </div>
          </div>
          <LocationModal
            modalOpen={openModalLocation}
            onCancel={() => {
              setOpenModalLocation(false);
              setIsLastItem(false);
              setSegmentActive(1);
            }}
            formLocation={form}
            onOk={() => {
              setSegmentActive(1);
            }}
            isLastItem={isLastItem}
            segmentActive={segmentActive}
            listTransships={listTransships}
          />
        </Form>
      </Card>
    </Layout>
  );
}

export default LocationSetting;
